import loadable from '@loadable/component';
import { LOADABLE_NO_SSR } from 'shared/utils/loadable';

export const ActionsCentersLoadable = loadable(() => import('./ActionsCenters'), { ...LOADABLE_NO_SSR });
